import styled from "styled-components";
import { Colors, GrayColors, TextColorNames } from "@smartsuite/types";

// Convert hex color to rgba, needed for the background color with transparency 10% of the output data available fields title
const hexToRgba = (hex: string, alpha = 1): string => {
  hex = hex.replace(/^#/, "");

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px 20px;
`;

export const Title = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 20px;
  line-height: 18px;
`;
export const ItemWrapper = styled.div`
  display: inline-flex;
  margin-bottom: 5px;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
`;

export const Item = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
`;

export const IconWrapper = styled.div<{ top: string }>`
  display: inline-flex;
  position: relative;
  top: ${({ top }) => top};
`;

export const IconCopyWrapper = styled.div`
  display: inline-flex;
  position: relative;
  top: 2px;
  margin-left: 8px;
  color: ${TextColorNames.tertiary};
  opacity: 0.4;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const LabelWrapper = styled.div`
  display: inline-flex;
  flex-basis: 30%;
`;

export const ButtonWrapper = styled.div`
  display: inline-flex;
  justify-content: flex-end;
`;

export const Hr = styled.hr`
  border: none;
  width: 100%;
  border-top: 1px solid ${GrayColors["G-1-5"]};
`;

export const InputData = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px solid ${GrayColors["G-1-5"]};
  min-height: 110px;
  border-radius: 8px;
  margin-bottom: 10px;
`;

export const InputDataTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  line-height: 24px;
`;

export const InputDataItemWrapper = styled.div<{ expanded: boolean }>`
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  max-height: ${({ expanded }) => (expanded ? "100%" : "120px")};
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  margin-bottom: 10px;
`;

export const InputDataItem = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: 8px;
  line-height: 25px;
  font-weight: 500;
  font-size: 13px;
  color: ${TextColorNames.tertiary};
`;

export const InputDataItemLabel = styled.div`
  display: inline-flex;
`;
export const InputDataItemValue = styled.div`
  display: inline-flex;
  word-break: break-all;
`;

export const InputDataExpand = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: 5px;
  padding-top: 10px;
  border-top: 1px solid ${GrayColors["G-1-5"]};
  font-weight: 500;
  font-size: 12px;
  line-height: 25px;
  color: ${TextColorNames.tertiary};
  cursor: pointer;

  &:hover {
    color: ${TextColorNames.primary};
  }
`;

export const OutputData = styled.div`
  display: inline-flex;
  gap: 10px;
  border: 1px solid ${hexToRgba(Colors.bBlue, 0.1)};
  border-radius: 8px;
  flex-direction: column;
  & > div {
    padding: 12px;
  }
  padding-bottom: 20px;
`;

export const OutputDataTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  border-color: ${Colors.bBlue};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: ${hexToRgba(Colors.bBlue, 0.1)};
`;

export const OutputDataItemWrapper = styled.div``;

export const OutputDataItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  border-bottom: 1px solid ${GrayColors["G-1-5"]};
  line-height: 25px;
  font-weight: 500;
  font-size: 13px;
  color: ${TextColorNames.tertiary};
`;

export const OutputDataItemLabel = styled.div`
  display: inline-flex;
  flex-basis: 25%;
`;
export const OutputDataItemValue = styled.div<{ noValue: boolean }>`
  display: inline-flex;
  color: ${({ noValue }) => (noValue ? Colors.custom6 : "inherit")};
  word-break: break-all;
`;
